// src/features/simulators/mobile-desk/components/MobileDeskSimulator.tsx

import React, { useState, useCallback } from 'react';
import { useTranslate } from 'react-admin';
import { PhoneAndroid as MobileDeskIcon } from '@mui/icons-material';
import { SimulatorWizard } from '../../shared/components/SimulatorWizard';
import { useSimulatorWizard } from '../../shared/hooks/useSimulatorWizard';
import { MobileDeskConfigForm } from './MobileDeskConfigForm';
import { useMobileDeskSimulation } from '../hooks/useMobileDeskSimulation';
import { GuestType, KeyDeliveryMethod } from '../../shared/types/journey.types';
import { DocumentScanMethod, MOBILE_DESK_DEVICE_TYPE, MOBILE_DESK_CHANNEL } from '../types';
import type { MobileDeskConfigValues } from './MobileDeskConfigForm';

export const MobileDeskSimulator: React.FC = () => {
  const translate = useTranslate();
  const wizard = useSimulatorWizard({ deviceType: MOBILE_DESK_DEVICE_TYPE, channel: MOBILE_DESK_CHANNEL });
  const { simulate } = useMobileDeskSimulation();

  const [config, setConfig] = useState<MobileDeskConfigValues>({
    guestType: GuestType.RESERVATION,
    keyDeliveryMethod: KeyDeliveryMethod.DIGITAL_MOBILE,
    documentScanMethod: DocumentScanMethod.AUTOMATIC,
    reservationNumber: '',
    autoGenerateReservation: true,
  });

  const handleRun = useCallback(() => {
    wizard.runSimulation(async (client, addLog) => {
      return simulate(client, addLog, wizard.deviceId, wizard.hotelId, config);
    });
  }, [wizard, simulate, config]);

  return (
    <SimulatorWizard
      title={translate('resources.simulators.mobile_desk.title')}
      subtitle={translate('resources.simulators.mobile_desk.description')}
      icon={<MobileDeskIcon />}
      wizard={wizard}
      deviceType={MOBILE_DESK_DEVICE_TYPE}
      channel={MOBILE_DESK_CHANNEL}
      configForm={
        <MobileDeskConfigForm
          values={config}
          onChange={setConfig}
        />
      }
      onRun={handleRun}
    />
  );
};

export default MobileDeskSimulator;
